<div class="d-flex align-header">
    <div class="date"><span class="date-label">Updated on</span>&nbsp;&nbsp;{{apiHitTime|
        date:'dd-MMM-y hh:mm:ss aaa':'en-US'}}</div>
    <div *ngIf="!sharedService.rbacManagement('events_alerts_DateTimeRange')" class="filter-drop-down dropdown att-filter align-end rt-filter show-arrow">
        <mat-form-field appearance="outline">
            <mat-select [disableOptionCentering]="true" [formControl]="period" placeholder="Period">
                <mat-option *ngFor="let item of periodList" [value]="item" (click)="onPeriodFilterChange()">
                    {{item.name | titlecase}}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <div *ngIf="sharedService.rbacManagement('events_alerts_DateTimeRange')" class="d-flex gap-2 align-items-center">
        <div class="widget-edit pdt-5 calender-pop-scroll report-date-field home-datetime-range">
          <form [formGroup]="datepickerForm">
          <app-datetime-range class="" formControlName="thisdate" [isDisabled]="false" [label]="'Date Range'" [autoApply]="false"
            [showCancel]="true" [timePicker]="true" [timePicker24Hour]="true" [timePickerSeconds]="true"
            [showCustomRangeLabel]="true" [alwaysShowCalendars]="true" [keepCalendarOpeningWithRange]="true" 
            [opens]="'left'" (datePassed)="saveTime($event)">
          </app-datetime-range>
          </form>
        </div>
      </div>
</div> 

<app-common-table [tableData]="alertsMaster" [columnHeader]="columnHeader" [pageType]="'alerts'" [hasStickyHeader]="alertsMaster.length > 0 ? true : false"
    class="app-common-table" [actionPermission]="{view:false,edit:false,delete:false,download:false,alert:true,acknowledge:true, pagination:false,
        createIncident:sharedService.rbacManagement('entities_Alerts_Incident')}" (tableAction)="tableAction($event)" (pageSizeChange)="onPageSizeChange($event)">
</app-common-table>
<app-standard-pagination [pagination]="pager" backgroundColor="'#f8f8f8'"
*ngIf="alertsMaster?.length && pager && pager?.pages?.length > 1" (paginationAction)="onPaginateChange($event)">
</app-standard-pagination>